import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "../../shared/shared.module";

import { ScannerModule } from "../scanner/scanner.module";
import { ArticleLogistiqueFormComponent } from "./components/article-logistique-form/article-logistique-form.component";
import { D3Module } from "../d3/d3.module";
import { DocLocalComponent } from "../documents/containers/doc-local/doc-local.component";
import { ArticleCardComponent } from "../../shared/components/article-card/article-card.component";
import { StickyPageDirective } from "../../shared/services/edition-store/edition-actions/sticky-page.directive";
import { FileDropperComponent } from "../../shared/components/file-dropper/file-dropper.component";
import { TitleComponent } from "../../shared/components/title/title.component";
import { BigButtonComponent } from "../../shared/components/big-button/big-button.component";
import { InputNumberComponent } from "../../shared/components/input-number/input-number.component";

@NgModule({
  declarations: [ArticleLogistiqueFormComponent],
  imports: [
    CommonModule,
    SharedModule,
    ScannerModule,
    D3Module,
    DocLocalComponent,
    ArticleCardComponent,
    StickyPageDirective,
    FileDropperComponent,
    TitleComponent,
    BigButtonComponent,
    InputNumberComponent,
  ],
  exports: [ArticleLogistiqueFormComponent],
})
export class ArticlesModule {}
